// BUT-0038: Warnung bei ungespeicherten Eingaben – EINE zentrale Stelle für die ganze Suite.
// Merkzeichen "ungespeichert" wird bei Eingaben gesetzt (außer Suchfelder/Filter/Datei),
// nach jedem erfolgreichen Speichern (POST/PUT/PATCH/DELETE) und nach jedem Seitenwechsel gelöscht.
// Ausnahme für Felder: Attribut data-keine-warnung am Feld oder einem Vorfahren.
import { api } from "@/lib/api";

const TEXT = "Sie verlassen jetzt diese Seite.\nIhre Eingaben sind noch nicht gespeichert.\n\nTrotzdem verlassen?";
let installiert = false;
let ungespeichert = false;
const offene = new Set(); // Schlüssel, die Seiten selbst melden (z. B. "projekt-<id>"); nur die Meldenden leeren sie
// Frage "Trotzdem verlassen?" mit dem gleichen Text für Seiten, die selbst schließen (z. B. Vorlage bearbeiten)
export const frageVerlassen = () => window.confirm(TEXT);
export function meldeUngespeichert(schluessel, wert) {
  if (wert) offene.add(schluessel); else offene.delete(schluessel);
}
const schmutzig = () => ungespeichert || offene.size > 0;
let letzteUrl = "";
let letzterStand = null;

const istAusgenommen = (el) => {
  if (!el || !el.tagName) return true;
  const tag = el.tagName.toLowerCase();
  const editierbar = tag === "input" || tag === "textarea" || tag === "select" || el.isContentEditable;
  if (!editierbar) return true;
  if (tag === "input") {
    const t = (el.getAttribute("type") || "text").toLowerCase();
    if (t === "search" || t === "file") return true;
  }
  if (el.closest && el.closest("[data-keine-warnung]")) return true;
  // Suchfelder (Platzhalter enthält „such“, z. B. „Vorlage suchen…“, „E-Mails durchsuchen…“) oder role="search": nur Suche, keine Eingabe.
  // Ausnahme: Felder, die zugleich Daten erfassen, tragen data-echte-eingabe (z. B. Name im Einsatz).
  if (el.hasAttribute && el.hasAttribute("data-echte-eingabe")) return false;
  if (/such/i.test(el.getAttribute("placeholder") || "")) return true;
  if (el.getAttribute("role") === "search" || (el.closest && el.closest('[role="search"]'))) return true;
  return false;
};

const merken = () => { letzteUrl = window.location.href; letzterStand = window.history.state; };
const pfadVon = (url) => { try { return new URL(url, window.location.href).pathname; } catch { return null; } };

// true = darf wechseln
const darfVerlassen = () => {
  if (!schmutzig()) return true;
  if (window.confirm(TEXT)) { ungespeichert = false; offene.clear(); return true; }
  return false;
};

export function installiereUngespeichertWarnung() {
  if (installiert || typeof window === "undefined") return;
  installiert = true;
  merken();

  const setzen = (e) => { if (!istAusgenommen(e.target)) ungespeichert = true; };
  document.addEventListener("input", setzen, true);
  document.addEventListener("change", setzen, true);

  // Nach erfolgreichem Speichern zurücksetzen
  api.interceptors.response.use((res) => {
    const m = String(res?.config?.method || "").toLowerCase();
    // Datei-Uploads (multipart/FormData) sind kein Speichern der Karte
    const ct = String(res?.config?.headers?.["Content-Type"] || res?.config?.headers?.get?.("Content-Type") || "");
    const upload = (typeof FormData !== "undefined" && res?.config?.data instanceof FormData) || /multipart/i.test(ct);
    if (!upload && ["post", "put", "patch", "delete"].includes(m)) ungespeichert = false;
    return res;
  });

  // Links: Klick abfangen, bevor React Router ihn sieht (sauberster Weg)
  document.addEventListener("click", (e) => {
    if (!schmutzig() || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest("a[href]");
    if (!a || (a.target && a.target !== "_self") || a.hasAttribute("download")) return;
    let u;
    try { u = new URL(a.href, window.location.href); } catch { return; }
    if (u.origin !== window.location.origin) return; // fremde Seite: beforeunload
    if (u.pathname === window.location.pathname) return;
    if (!darfVerlassen()) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
  }, true);

  // Programmatische Wechsel (navigate()): pushState/replaceState umhüllen
  ["pushState", "replaceState"].forEach((name) => {
    const original = window.history[name].bind(window.history);
    window.history[name] = function (state, titel, url) {
      const wechsel = url != null && pfadVon(url) !== window.location.pathname;
      // Abbruch: nichts tun. Der Router liest danach window.location (alte Seite) und bleibt dort.
      if (wechsel && !darfVerlassen()) return;
      original(state, titel, url);
      if (wechsel) { ungespeichert = false; offene.clear(); }
      merken();
    };
  });
  // Zurück-Knopf: vor dem Router abfangen; bei Abbruch alte Seite wiederherstellen
  window.addEventListener("popstate", (e) => {
    const neuPfad = window.location.pathname;
    const altPfad = pfadVon(letzteUrl);
    if (neuPfad === altPfad || !schmutzig()) { merken(); return; }
    if (window.confirm(TEXT)) { ungespeichert = false; offene.clear(); merken(); return; }
    e.stopImmediatePropagation();
    Object.getPrototypeOf(window.history).pushState.call(window.history, letzterStand, "", letzteUrl);
  }, true);

  window.addEventListener("beforeunload", (e) => {
    if (!schmutzig()) return;
    e.preventDefault();
    e.returnValue = "";
  });
}
